import Alpine from 'alpinejs';

const EXPIRY_MS = 24 * 60 * 60 * 1000;

export default function audioPlayer() {
  return {
    _trackIndex: Alpine.$persist(null).as('blueprint_audio_index'),
    _trackTime: Alpine.$persist(0).as('blueprint_audio_time'),
    _isPlaying: Alpine.$persist(false).as('blueprint_audio_playing'),
    _savedAt: Alpine.$persist(0).as('blueprint_audio_saved'),

    tracks: [],
    isPlaying: false,
    currentTime: 0,
    duration: 0,
    audio: null,

    get track() {
      return this.tracks[this._trackIndex] ?? null;
    },

    init() {
      const el = document.getElementById('audio-player-tracks');
      if (!el) return;

      this.tracks = JSON.parse(el.textContent);
      if (!this.tracks.length) return;

      const expired = !this._savedAt || Date.now() - this._savedAt > EXPIRY_MS;

      if (expired || this._trackIndex === null || this._trackIndex >= this.tracks.length) {
        this._trackIndex = Math.floor(Math.random() * this.tracks.length);
        this._trackTime = 0;
        this._isPlaying = false;
      }

      this.currentTime = this._trackTime;

      this.audio = new Audio(this.track.src);

      this.audio.addEventListener('loadedmetadata', () => {
        this.duration = this.audio.duration;
        this.audio.currentTime = this._trackTime;

        if (this._isPlaying) {
          this.audio
            .play()
            .then(() => {
              this.isPlaying = true;
            })
            .catch(() => {
              this._isPlaying = false;
            });
        }
      });

      this.audio.addEventListener('timeupdate', () => {
        this.currentTime = this.audio.currentTime;
        this._trackTime = Math.floor(this.audio.currentTime);
        this._savedAt = Date.now();
      });

      this.audio.addEventListener('ended', () => this.next());
    },

    togglePlay() {
      if (!this.audio) return;
      if (this.isPlaying) {
        this.audio.pause();
        this.isPlaying = false;
        this._isPlaying = false;
      } else {
        this.audio.play();
        this.isPlaying = true;
        this._isPlaying = true;
        this._savedAt = Date.now();
      }
    },

    loadTrack(index) {
      if (!this.audio) return;
      const wasPlaying = this.isPlaying;
      this._trackIndex = index;
      this._trackTime = 0;
      this._savedAt = Date.now();
      this.audio.pause();
      this.audio.src = this.track.src;
      this.audio.currentTime = 0;
      this.currentTime = 0;
      this.duration = 0;
      this.isPlaying = false;

      if (wasPlaying) {
        this.audio.play();
        this.isPlaying = true;
        this._isPlaying = true;
      }
    },

    prev() {
      this.loadTrack((this._trackIndex - 1 + this.tracks.length) % this.tracks.length);
    },

    next() {
      this.loadTrack((this._trackIndex + 1) % this.tracks.length);
    },

    seek(e) {
      if (!this.audio || !this.duration) return;
      const rect = e.currentTarget.getBoundingClientRect();
      const pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      this.audio.currentTime = pct * this.duration;
    },

    formatTime(secs) {
      if (!secs || isNaN(secs)) return '0:00';
      const m = Math.floor(secs / 60);
      const s = Math.floor(secs % 60)
        .toString()
        .padStart(2, '0');
      return `${m}:${s}`;
    },
  };
}
